module.exports = __webpack_public_path__ + "static/media/Vector.46027ad3.svg";